export default "__VITE_ASSET__3647bc7e__"